import { useOrg } from '@/contexts/OrgContext';
import { Select } from '@/lib/base/forms/select/select';
import { useAssociationTypes } from '@/lib/crm/hooks/useAssociationTypes';
import { getPropertyTypeIconComponent } from '@/lib/crm/utils/icons/PropertyTypeIcon';

import { SelectInputError, SelectInputLoading } from './SelectInputStates';
import type { PropertyInputProps } from './TextInput';

export const AssociationTypeSelectInput: React.FC<PropertyInputProps> = ({
  propertyType,
  value,
  onChange,
  disabled = false,
  inputRef,
  placeholder,
  size = 'sm',
}) => {
  const { currentOrg } = useOrg();
  const orgId = currentOrg?.id;

  const { associationTypes, isLoading, error } = useAssociationTypes(orgId);

  const items = associationTypes.map(a => ({
    id: a.association_type_name,
    label: a.label,
  }));

  const Icon = getPropertyTypeIconComponent(propertyType);

  if (isLoading) {
    return <SelectInputLoading />;
  }

  if (error) {
    return <SelectInputError error={error} />;
  }

  return (
    <Select.ComboBox
      placeholder={placeholder || `Select ${propertyType.label.toLowerCase()}`}
      size={size}
      items={items}
      selectedKey={value !== null && value !== undefined ? String(value) : null}
      onSelectionChange={key =>
        onChange(key !== null && key !== undefined ? String(key) : null)
      }
      isDisabled={disabled}
      shortcut={false}
      aria-label={propertyType.label}
      icon={Icon}
      ref={inputRef}
    >
      {item => <Select.Item id={item.id}>{item.label}</Select.Item>}
    </Select.ComboBox>
  );
};
